import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';
import { AssignedAuditModel, AuditAllData } from 'src/app/classes/audit';

// import { Router } from '@angular/router';

import { Page } from 'src/app/classes/page';
import { AuditService } from 'src/app/services/audit.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ToastService } from 'src/app/toast/toast.service';
import { AllotDepartmentAuditComponent } from '../allot-department-audit/allot-department-audit.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FinalChecklistService } from 'src/app/services/finalchecklist.service';
import { AuditStatusService } from 'src/app/services/Auditstatus.service';
import { SweetAlertService } from 'src/app/toast/sweet-alert.service';
import { AllotService } from 'src/app/services/Allot.service';
declare var bootstrap: any;
@Component({
  selector: 'app-assigned-audited-societies',
  templateUrl: './assigned-audited-societies.component.html',
  styleUrls: ['./assigned-audited-societies.component.scss']
})
export class AssignedAuditedSocietiesComponent {

  page = new Page();
  rows: any[] = [];
  loading = false;
  private scrollposition = 0;
  columns: any[] = [];
  selectedViewRole: number = 1;
  selectedRole: number = 2;
  filter: any = {
    districtId: 0,
    blockId: 0,
    societyDetailId: 0,
    societyTypeId: 0,
    isStatus: '',
    circleId: 0,

  };


  filteredSocietyData: any[] = [];
  searchText: string = '';

  blocksData: any[] = [];
  circlesData: any[] = [];
  districts: any[] = [];
  statusid: any;
  isSubmit: Boolean = false;
  errorMessage: string = '';
  district: string = '';
  circle: string = '';
  block: string = '';
  address: string = '';
  designation: string = '';
  experience: string = '';
  mobile: string = '';
  email: string = '';
  auditortype: string = '';
  password: string = '';
  confirmPassword: string = '';
  category: string = '';
  userType: string = '';
  ddlStatus: string = '';
  roleid: number = 0;
  data: any;
  forward: any;
  selectedSocietyId: number = 0;
  transids: number = 0;
  // userData: AssignedAuditModel[] = [];
  // MasterData: AuditAllData[] = [];


  MasterData: any[] = [];
  isBlockVisible: boolean = true;

  filteredData: any[] = [];
  auditedSocietyData: any[] = [];
  societyAndAuditorData: any[] = [];
  hrremark: any
  p: number = 1;
  test: any;
  allotment: any;




  districtFilter: any[] = [];
  blockFilter: any[] = [];
  societyFilter: any[] = [];
  societyTypeFilter: any[] = [];


  constructor(private authService: AuthService, private allotService: AllotService,
    private alertService: SweetAlertService, private finalchecklist: FinalChecklistService, private auditstatus: AuditStatusService, private modalService: NgbModal, private auditService: AuditService, private toastService: ToastService, private route: ActivatedRoute,
    private router: Router) {
    {
      this.page.pageNumber = 0;
      this.page.pageSize = 10;
    }
  }

  ngOnInit(): void {
    this.roleid = this.authService.currentUserValue.roleId;
    this.route.params.subscribe((params) => {
      if (params['id']) {

        this.statusid = parseInt(params['id']);
      }
    });
    //this.id = Number(this.route.snapshot.paramMap.get('id'));

    this.columns = [

      { prop: 'ssocietyname', name: 'Society Name' },
      { prop: 'ssocietytype', name: 'Society Type' },
      { prop: 'ssecretaryname', name: 'Secretary Name' },
      { prop: 'sdistrictname', name: 'District' },
      { prop: 'sblockname', name: 'Block Inspector' },
      { prop: 'verifierName', name: 'Verifier Name' },
      { prop: 'verifierMobile', name: 'Verifier Mobile No.' },

      //{ prop: 'role', name: 'Request Type' }
    ];
    this.setPage({ offset: 0 });
    this.getFiltersData();
    this.bindDistrict(0);
    this.auditdates();

  }

  searchDataByFilters(): void {
    this.setPage({ offset: 0 });
  }

  onUserTypeChange(event: Event): void {
    const selectedId = Number((event.target as HTMLSelectElement).value); // Convert to number
    if (selectedId === 12 || selectedId === 19 || selectedId === 10) {
      this.isBlockVisible = false;
    } else {
      this.isBlockVisible = true;
    }
  }
  setPage(pageInfo: any) {
    this.page.pageNumber = pageInfo.offset;
    var postData = {
      pageSize: this.page.pageSize,
      pageNumber: this.page.pageNumber,
      totalRecords: 0,
      filter: {
        status: this.statusid,
        districtId: this.filter.districtId,
        blockId: this.filter.blockId,
        societyDetailId: this.filter.societyDetailId,
        societyTypeId: this.filter.societyTypeId,
        isStatus: this.filter.isStatus,
        circleId: this.filter.circleId
      },
    };

    this.loading = true;
    this.auditService.getAuditedSocieties(postData).subscribe({

      next: (response) => {
        this.loading = false;
        if (response.status === 200) {
          this.auditstatus.SetStatus(this.statusid);


          //  this.rows = response.data;
          this.rows = response.data.map((row: any) => ({
            ...row,
            role: row.requestType === "Liquidator" ? "Liquidator Audit" : (row.requestType === null || row.requestType === "Auditor" ? "Auditor" : "Unknown"),

            isDisabled: row.requestType === 'Liquidator',
            assigned: row.sauditstatus === 'Verification Assigned',
            isCheckListCompleted: row.isCheckListCompleted,
            ispayment: row.payment,
            isMoveForward: row.isForwarded,
            isAllotmentStatus: row.allotmentStatus,



          }));

          this.data = this.rows;
          
          this.hrremark = this.data.map((item: any) => item.redirectToHrRemark);
          this.arRejectionRemark = this.data.map((item: any) => item.auditorRequestCancelRemark);



          this.page.totalRecords = response.totalRecords;

        } else {
          this.rows = [];
        }
      },
      error: (error) => {
        this.loading = false;
        console.error('Error fetching auditors:', error);
      },
    });

  }
  acceptedRows: { [id: number]: boolean } = {};
  selectedRow: any = null;
  actionTaken: boolean = false;
  markAccepted(id: number) {
    this.acceptedRows[id] = true;
    this.actionTaken = true;

  }
  onReject(id: number): void {
    this.acceptedRows[id] = true;
    this.actionTaken = true;
  }

  onDistrictChange(event: Event) {

    const iDistrictID = Number((event.target as HTMLSelectElement).value);
    this.auditService.bindDistrict(iDistrictID).subscribe(
      (response) => {

        if (response.status === 200) {
          this.circlesData = response.lstCircle;
        } else {
          this.toastService.showError(response.message);
        }
      },
      (error) => {
        // Handle any errors that occur during the request
        this.errorMessage = 'Error fetching dropdown data: ' + error.message;
        console.error('Error fetching dropdown data:', error);
      }
    );
  }

  onCircleChange(event: Event) {
    const iDistrictID = Number((event.target as HTMLSelectElement).value);
    this.auditService.bindDistrict(iDistrictID).subscribe(
      (response) => {

        if (response.status === 200) {
          this.blocksData = response.lstBlock;
        } else {
          this.toastService.showError(response.message);
        }
      },
      (error) => {
        // Handle any errors that occur during the request
        this.errorMessage = 'Error fetching dropdown data: ' + error.message;
        console.error('Error fetching dropdown data:', error);
      }
    );
  }
  get startEntry(): number {
    return (this.page.pageNumber * this.page.pageSize) + 1;
  }

  get endEntry(): number {
    return Math.min((this.page.pageNumber + 1) * this.page.pageSize, this.page.totalRecords);
  }

  // Method to handle page size change
  onRowsPerPageChange() {
    this.page.pageNumber = 0;
    this.setPage({ offset: 0 });
  }

  bindDistrict(iDistrictID: number): void {
    this.auditService.bindDistrict(iDistrictID).subscribe(
      (response) => {

        if (response.status === 200) {
          this.districts = response.lstDistrict;
        } else {

          this.toastService.showError(response.message);
        }
      },
      (error) => {
        // Handle any errors that occur during the request
        this.errorMessage = 'Error fetching dropdown data: ' + error.message;
        console.error('Error fetching dropdown data:', error);
      }
    );
  }

  filterList(list: any[], searchText: string, keys: string[]): any[] {
    if (!searchText) return list; // If search is empty, return full list

    searchText = searchText.toLowerCase();

    return list.filter((item) =>
      keys.some((key) =>
        item[key]?.toString().toLowerCase().includes(searchText)
      )
    );
  }

  filterSocietyTable(): void {
    this.filteredSocietyData = this.filterList(this.auditedSocietyData, this.searchText, [
      'ssocietyname',
      'ssocietytype',
      'ssecretaryname',
      'sdistrictname',
      'sblockname',
      'sauditstatus'
    ]);
  }







  processToVerifier(isocietydetailsid: number, transId: number) {

    this.transids = transId
    this.selectedSocietyId = isocietydetailsid;
    this.router.navigate(['/audit/assignverifier', this.selectedSocietyId, this.transids]);
  }


  processToViewChecklist(isocietydetailsid: number, transId: number) {
    this.statusid = this.auditstatus.getStatus();

    this.transids = transId
    this.selectedSocietyId = isocietydetailsid;
    this.router.navigate(['/audit/view-checklist', this.selectedSocietyId, this.transids]);
  }



  getFiltersData(): void {

    this.auditService.getFiltersData().subscribe(
      (response) => {

        if (response.status === 200) {
          this.districtFilter = response.data.districts;
          this.blockFilter = response.data.blocks;
          this.societyFilter = response.data.society;
          this.societyTypeFilter = response.data.societyType;
        } else {

          this.toastService.showError(response.message);
        }
      },
      (error) => {
        // Handle any errors that occur during the request
        this.errorMessage = 'Error fetching dropdown data: ' + error.message;
      }
    );
  }

  openNewTab(url: string): void {
    window.open(url, '_blank');
  }
  auditData: any;
  auditdates(): void {
    this.allotService.getAuditAssignDate().subscribe(
      (response: any) => {
        this.auditData = response.data;
        

      },
      (error: { message: string }) => {
        this.toastService.showError(error.message);
      }
    );
  }
async openAllotAuditor(
  isocietydetailsid: number,
  iAllotAuditorID: number,
  ssocietyname: string
) {
  if (!this.auditData || !Array.isArray(this.auditData)) {
    this.toastService.showError("Audit data not loaded yet.");
    return;
  }

  const arAuditData = this.auditData.find(
    (row: any) => row.arAuditEndDate 
  );

  const normalize = (date: Date) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  };

  const today = normalize(new Date());

  //const arAuditstartDate = normalize(new Date(arAuditData.arAuditStartDate));   
  const arAuditEndDate = normalize(new Date(arAuditData.arAuditEndDate));   

  const allowAllotment =
    // today > arAuditEndDate && today < arAuditstartDate;
    today < arAuditEndDate ;

  if (allowAllotment) {
    const allotAuditor = this.statusid === 9 ? '0' : iAllotAuditorID;

    const modalRef = this.modalService.open(AllotDepartmentAuditComponent, {
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
    });

    modalRef.componentInstance.auditData = {
      selectedSocietyId: isocietydetailsid,
      allotAuditorID: allotAuditor,
      societyName: ssocietyname,
    };

    modalRef.result.then(
      (result: any) => {
        if (result === 'Data saved successfully!') {
          this.setPage({ offset: 0 });
        }
      },
      (reason: any) => {
       
      }
    );
  } else {
    await this.alertService.confirmAlert(
      'Allotment',
      'Audit allotment is already done for this year.',
      'OK',
      'Close'
    );
  }
}




  arRejectionRemark = '';
  remark = ''
  showRejectRemarkInput = false;

  onRejectClicked() {
    this.showRejectRemarkInput = true;
    this.selectedViewRole = 2;
  }


  get isArRemarkReadonly(): boolean {
    return this.selectedViewRole === 2 &&
      this.showRejectRemarkInput === true;
  }


  submitArSendBackRemark(transId: number, iAllotAuditorID: number) {
    if (!this.remark.trim()) {
      this.toastService.showError('Please enter a remark before submitting.');
      return;
    }

    const data = {
      remark: this.remark,
      iSocietyDetailsTranID: transId,
      roleID: 0,
      UserID: 0,
      action: this.ddlStatus,
      StatusID: this.statusid,
      iAllotAuditorID: iAllotAuditorID

    };

    this.finalchecklist.sendbackAR(data).subscribe(
      (response) => {
        this.toastService.showSuccess(response.message);
        this.router.navigate([`/dashboard`])
      },
      (error) => {
        this.toastService.showError(
          error.message || 'Error while rejecting the request.'
        );
      }
    );

    // After submit
    this.showRejectRemarkInput = false;
    this.arRejectionRemark = '';
  }



  cancelRejectRemark() {
    this.showRejectRemarkInput = false;
    this.arRejectionRemark = '';
    this.selectedViewRole = 0;
  }

  submitArRejectionRemark(transId: number, auditorId: number) {

    if (!this.arRejectionRemark.trim()) {
      this.toastService.showError('Please enter a remark before submitting.');
      return;
    }

    const data = {
      arRejectionRemark: this.arRejectionRemark,
      iAllotAuditorID: auditorId,
      iSocietyDetailsTranID: transId
    };

    this.finalchecklist.rejectionAR(data).subscribe(
      (response) => {
        this.toastService.showSuccess(response.message);
        this.router.navigate([`/dashboard`])

      },
      (error) => {
        this.toastService.showError(
          error.message || 'Error while rejecting the request.'
        );
      }
    );

    // After submit
    this.showRejectRemarkInput = false;
    this.arRejectionRemark = '';
  }







}
